/**
 * centralized prop types to pass to react components.
 */

import { shape, string, object, bool, array } from 'prop-types';

export const authUserType = shape({
  user: shape({
    primaryMember: shape({
      accountId: string.isRequired,
      firstName: string.isRequired,
      lastName: string,
      monitoredAccounts: shape({
        addresses: object,
        bankAccounts: object,
        creditDebitCards: object,
        driversLicense: object,
        emails: object,
        insuranceCards: object,
        mothersMaidenName: object,
        phoneNumbers: object,
      }),
      plan: object,
      primaryAddress: object,
      primaryAdministrator: bool,
      primaryEmail: object,
      primaryPhone: object,
      userName: string,
    })
  })
});



export const equifaxType = shape({
  equifax_status: string,
  credit_score_status: string,
  credit_report_status: string,
  credit_score_history_status: string,
  credit_score_history: array,
  creditScore_1B: object,
  creditScore_3B: object,
  credit_report: object,
  credit_score: object,
  credit_report_abstract_status: string,
  credit_report_abstract: array,
});

export const jwtType = shape({
  jwt: object,
  jwt_error: string,
  jwt_status: string
});



// WEBPACK FOOTER //
// ./src/helpers/propCheck.js